import axios from "axios";
import React from "react";

import { getUrlForBookings } from "../../utils/confighelpers";
import { clubSiteBase, lookVars, mergeLook, pickLang, useEmbedMode, useGoogleFont } from "../../utils/webWidgets";
import { useTrialClub } from "../trial/trialShared";

/**
 * /embed/button?kind=shop|trial|join&label=… (2026-11-01): the "As a button" block from public/embed.js.
 * A button in the club's look (GET shopClub) that opens the page in a new tab on the club's address.
 * Preview (?preview=1): the look comes from the Website & webshop editor.
 */
const PAGES = { shop: "shop", trial: "trial", join: "members/signup" };
const DEFAULT_LABEL = {
  en: { shop: "Buy credits", trial: "Try a class", join: "Join the club" },
  nl: { shop: "Lessen kopen", trial: "Probeer een les", join: "Word lid" },
};

export default function EmbedButton() {
  const { link } = useTrialClub();
  const mode = useEmbedMode();
  const [saved, setSaved] = React.useState(null);
  const q = React.useMemo(() => new URLSearchParams(window.location.search), []);
  const kind = PAGES[q.get("kind")] ? q.get("kind") : "shop";

  React.useEffect(() => {
    if (!link) return;
    axios
      .get(`${getUrlForBookings()}shopClub`, { params: { club: link } })
      .then((res) => setSaved(res?.data?.statusCode === 200 ? res.data.data : {}))
      .catch(() => setSaved({}));
  }, [link]);

  const look = mergeLook(mode.previewMessage?.look || saved?.look);
  const lang = pickLang(look, mode.lang);
  useGoogleFont(look.font === "site" ? mode.siteFont : look.font === "inter" ? "Inter" : look.font === "mulish" ? "Mulish" : "");
  const label = (q.get("label") || "").slice(0, 40) || look.labels?.[kind] || DEFAULT_LABEL[lang]?.[kind] || DEFAULT_LABEL.en[kind];
  const href = `${clubSiteBase(saved?.club?.myBookingLink || link)}${PAGES[kind]}`;

  return (
    <div style={lookVars(look, mode.siteFont)} className="bg-transparent p-1">
      <a
        href={mode.preview ? undefined : href}
        target="_blank"
        rel="noopener noreferrer"
        className="flex h-12 w-full items-center justify-center rounded-[var(--fc-r-btn)] bg-[var(--fc-brand)] px-5 text-[15px] font-extrabold text-[color:var(--fc-on-brand)] no-underline hover:opacity-90"
      >
        {label}
      </a>
    </div>
  );
}
